<template>
  <!-- Titre principal -->
  <div class="container my-3">
    <h1 class="fw-bold text-warning">
      <router-link to="/" class="text-decoration-none">
        <fa :icon="['fa', 'chevron-left']" class="fs-6 me-2" /> </router-link
      >Terrassement
    </h1>
    <div :class="['card', 'h-100', 'shadow-sm']">
      <div class="card-header">
        <h3 class="fw-bold">Gallerie d'images</h3>
        <p class="lead m-0">
          Découvrez nos réalisations en matière de terrassement à travers
          différentes catégories. Que ce soit pour des travaux d'aménagement
          d'abords, de parking, de pavage ou de nettoyage de chantier, nous
          mettons à disposition nos compétences pour répondre à vos besoins.
        </p>
      </div>
      <div class="card-body">
        <div class="card-info mt-2">
          <div
            id="carouselExampleAutoplay"
            class="carousel slide carousel-fade"
            data-bs-ride="carousel"
            data-bs-interval="2000"
          >
            <div class="carousel-inner">
              <!-- Utilisation de v-for pour chaque image générée dynamiquement -->
              <div
                class="carousel-item"
                v-for="(image, index) in allImages"
                :key="index"
                :class="{ active: index === 0 }"
              >
                <img
                  :src="
                    require(`@/assets/${image.directory}/${image.filename}.jpg`)
                  "
                  class="d-block w-100"
                  :alt="image.alt"
                />
                <div class="carousel-caption d-none d-md-block">
                  <h5>{{ image.alt }}</h5>
                </div>
              </div>
            </div>

            <!-- Contrôles du carrousel -->
            <button
              class="carousel-control-prev"
              type="button"
              v-bind:data-bs-target="'#carouselExampleAutoplay'"
              data-bs-slide="prev"
            >
              <span
                class="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
              <span class="visually-hidden">Previous</span>
            </button>
            <button
              class="carousel-control-next"
              type="button"
              v-bind:data-bs-target="'#carouselExampleAutoplay'"
              data-bs-slide="next"
            >
              <span
                class="carousel-control-next-icon"
                aria-hidden="true"
              ></span>
              <span class="visually-hidden">Next</span>
            </button>

            <!-- Indicateurs (cercles en bas) -->
            <div class="carousel-indicators">
              <button
                v-for="(image, index) in allImages"
                :key="index"
                type="button"
                :data-bs-target="'#carouselExampleAutoplay'"
                :data-bs-slide-to="index"
                :class="{ active: index === 0 }"
                aria-current="index === 0 ? 'true' : 'false'"
                aria-label="'Slide ' + (index + 1)"
              ></button>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <router-link
            :to="{
              name: 'DevisView'
            }"
            class="text-decoration-none mt-0"
          >
            <span class="icon-link text-primary">
              <fa :icon="'file-signature'" class="icon me-2" />
              Demande devis
            </span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      imagesTerrassements: [
        {
          directory: 'terrassement',
          filename: 'terrassement',
          total: 3,
          alt: 'Terrassement',
          description: 'Terrassement'
        },
        {
          directory: 'terrassement',
          filename: 'parking',
          total: 9,
          alt: 'Parking',
          description: 'Parking'
        },
        {
          directory: 'terrassement',
          filename: 'pavedallage_01_',
          total: 8,
          alt: 'Pave Dallage',
          description: 'Pave Dallage'
        },
        {
          directory: 'terrassement',
          filename: 'pavedallage_02_',
          total: 6,
          alt: 'Pave Dallage',
          description: 'Pave Dallage'
        },
        {
          directory: 'terrassement',
          filename: 'pavedallage_03_',
          total: 6,
          alt: 'Pave Dallage',
          description: 'Pave Dallage'
        },
        {
          directory: 'terrassement',
          filename: 'pierrebleue_',
          total: 4,
          alt: 'Pierre bleue',
          description: 'Pierre bleue'
        }
      ],
      // Ce tableau contient toutes les images générées dynamiquement
      allImages: []
    }
  },
  created() {
    this.generateImages()
  },
  methods: {
    generateImages() {
      const images = []
      this.imagesTerrassements.forEach(category => {
        if (category.total) {
          for (let i = 1; i <= category.total; i++) {
            images.push({
              directory: category.directory,
              filename: `${category.filename}${i}`, // Exemple: terrassement1, terrassement2...
              alt: `${category.alt} ${i}`,
              description: `${category.description} ${i}`
            })
          }
        }
      })
      this.allImages = images // Affectation des images générées à allImages
    },
    goToDevis() {
      this.$router.push({
        name: 'devis'
      })
    }
  }
}
</script>

<style scoped>
/* Style du carrousel */
.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.carousel-item img {
  width: 100%;
  object-fit: contain;
  height: 400px;
  /* Taille fixe pour les images du carrousel */
}

/* Contrôles du carrousel */
.carousel-control-prev-icon,
.carousel-control-next-icon {
  background-color: #f39c12;
  /* Couleur de l'icône des contrôles */
}

/* Indicateurs (cercles en bas) */
.carousel-indicators button {
  background-color: #f39c12 !important;
}

/* Apparence des éléments du carrousel */
.carousel-caption {
  background: rgba(0, 0, 0, 0.5);
  /* Fond légèrement transparent pour la légende */
  padding: 10px;
}

.center-banner h3 {
  font-size: 1.35rem;
}

.center-banner p {
  font-size: 1rem;
}

/* Mobile responsiveness */
@media (max-width: 800px) {
  .carousel-item img {
    height: 300px;
    /* Réduit la taille des images sur mobile */
  }
}

.carousel-caption h5,
.carousel-caption p {
  font-size: 0.85rem;
  color: #fff;
}

.container {
  padding: 20px;
}

.card {
  border-radius: 10px;
  overflow: hidden;
  border: none;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-width: 35rem;
}

.card-header {
  padding: 15px;
  border-bottom: none;
}

.card-header .lead {
  font-size: 0.85rem;
}

.container-plus-icon {
  display: flex;
  align-self: center;
  align-items: center;
  justify-content: center;
}

.container-plus-icon .fa-circle-plus {
  color: #f7c600;
  margin-right: 0.5rem;
}

.container-plus-icon img {
  width: 80px;
  margin-right: 0.5rem;
}

.card-title {
  color: #4a4a4a;
}

.card-text {
  font-size: 14px;
  color: #6c757d;
}

.card-footer {
  border-top: none;
  font-size: 0.85rem;
  justify-content: flex-end;
  display: flex;
}

.card-footer .icon-link {
  gap: none;
}

.card-body {
  font-size: 1rem;
  border-radius: 0.5rem;
  border: 2px solid transparent;
}
</style>
